class ArchiveControler {

  //
  //  ArchiveControler Documentatie
  //
  //  Voorbeelden: KMYachtbuilders, Keunstwurk
  //
  //  - Breng Ajax functies binnen een archive
  //  - Geen specifieke HTML logica, wel loading, etc.
  //  - Pagina wordt in eerste instantie gevuld via PHP
  //
  //  Depandancy: jQuery - voor $.get functie
  //
  //  1. Registreer Ajax URL (archivepagina meestal)
  //  2. (optioneel) Registreer filters
  //  3. (optioneel) Registreer zoeken
  //  4. (optioneel) Gebruik paginatie / lees meer (registreer class)
  //  5. (optioneel) Gebruik callbacks (ondersteund standaard functie per event)
  //

  constructor() {
    this.version = 1.1;               // versiebeheer van script
    this.ajax_url = false;            // URL waar calls naar toe gaan
                                      // Kan handmatig of via archive_container data-ajaxurl="permalink"
    this.self_loading = false;        // zelf bezig
    if( undefined == window.archives_loading )
      window.archives_loading = 0;     // kunnen meerdere laden (voor body class)

    this.filters_checkboxgroup = [];  // element (met meerder checkbox-opties en data-param="parameter naam")
    this.filters_select = [];         // element (met 1 keuze optie en data-param="parameter naam")
    this.search_input = null;         // element
    this.counter = null;              // element
    this.more_button_classname = '';  // button wordt overschreven per call
    this.self_loading_classname = ''; // eigen loadingclass voor de body
    this.pillstrip_classname = '';

    this.archive_container = null;    // ajax vervangt innerHTML
    this.archive_observer = null;     // monitor innerHTML

    this.filter_timer = null;
    this.callbacks = {
      'change' : null
    };
  }

  // Config

  set_ajax_url( _url ) {
    this.ajax_url = _url;
  }

  register_filter_select( _el ) {
    if( _el == null ) return;
    if( !_el.hasAttribute('data-param') ) { console.log('filter mist parameter'); return; }
    _el.addEventListener('change', this.update_filters.bind(this));
    this.filters_select.push(_el);
  }

  register_filter_checkboxgroup( _el ) {
    if( _el == null ) return;
    if( !_el.hasAttribute('data-param') ) { console.log('filter mist parameter'); return; }
    _el.querySelectorAll('input[type=checkbox]').forEach( (_cb, $i) => {
      _cb.addEventListener('click', this.start_filter_timer.bind(this));
    });
    this.filters_checkboxgroup.push(_el);
  }

  register_counter( _el ) {
    if( _el == null ) return;
    this.counter = _el;
  }

  register_search_input( _el ) {
    if( _el == null ) return;
    if( 'onsearch' in _el ) {
      _el.addEventListener('search', this.update_search.bind(this));
    } else {
      _el.addEventListener('keydown', this.update_search_on_enter.bind(this));
    }
    this.search_input = _el;
  }

  register_archive_container( _el ) {
    if( _el == null ) return;
    if( !this.ajax_url && _el.hasAttribute('data-ajaxurl') ) {
      this.ajax_url = _el.getAttribute('data-ajaxurl');
    }

    this.archive_observer = new MutationObserver( this.archive_changed.bind(this) );
    this.archive_observer.observe( _el, { 
      childList: true,
      subtree: false // indien noodzakelijk true, default false 
    });
    this.archive_container = _el;
  }

  register_pillstrip_classname( _classname ) {
    this.pillstrip_classname = _classname;
    this.set_pill_buttons();
  }

  register_more_button_classname( _classname ) {
    this.more_button_classname = _classname;
    this.set_more_button();
  }

  register_self_loading_classname( _classname ) {
    this.self_loading_classname = _classname;
  }

  on( _eventname, _callback_function ) {
    if( !(typeof _callback_function == 'function') ) { console.log('callback mist functie'); return; }
    if( !this.callbacks.hasOwnProperty(_eventname )){ console.log('onbekend event voor callback'); return; }
    this.callbacks[_eventname] = _callback_function;
  }

  set_more_button() {
    if( !this.more_button_classname ) return;
    const more_btn = this.archive_container.querySelector('.' + this.more_button_classname);
    if( more_btn ) more_btn.addEventListener( 'click', this.update_more.bind(this) );
  }

  set_pill_buttons() {
    if( !this.pillstrip_classname ) return;
    const pills = this.archive_container.querySelector('.' + this.pillstrip_classname);
    if( pills ) pills.addEventListener( 'click', (e) => {
      if( e.target.tagName == 'BUTTON') {
        let option_id = e.target.getAttribute('data-option-id');
        let option = document.querySelector(`input[type=checkbox]#${option_id}`);
        if( option ) option.checked = false;
        this.update_archive(1);
      }
    });
  }

  // Filter timer (delay on mulitselect filter)
  start_filter_timer() {
    if( this.filter_timer !== null ) clearTimeout(this.filter_timer);
    var self = this;
    this.filter_timer = setTimeout( function() {
      self.update_archive(1);
    }, 1000);
  }

  // Loading

  start_loading() {
    this.self_loading = true;
    window.archives_loading += 1;

    this.filters_select.forEach( filter => filter.disabled = true );
    if( this.search_input ) this.search_input.readOnly = true;

    if( !document.body.classList.contains('archives-loading') )
      document.body.classList.add('archives-loading');
    if( this.self_loading_classname && !document.body.classList.contains(this.self_loading_classname) )
      document.body.classList.add(this.self_loading_classname);
  }

  stop_loading() {
    this.self_loading = false;
    window.archives_loading -= 1;

    this.filters_select.forEach( filter => filter.disabled = false );
    if( this.search_input ) this.search_input.readOnly = false;

    if( window.archives_loading === 0 && document.body.classList.contains('archives-loading'))
      document.body.classList.remove('archives-loading');
    if( this.self_loading_classname && document.body.classList.contains(this.self_loading_classname) )
      document.body.classList.remove(this.self_loading_classname);
  }

  // Input Events

  archive_changed() {
    this.set_more_button();
    this.set_pill_buttons();
    if( typeof this.callbacks['change'] === 'function' )
      this.callbacks['change'](this);
    // Callback mogelijk voor animaties e.d.
    // Bijvoorbeeld door een class "new" weg te halen o.i.d.
  }

  update_filters( e ) {
    e.preventDefault();
    this.update_archive(1);
  }

  update_search() {
    this.update_archive(1);
  }

  update_more( e ) {
    if( ['BUTTON','SPAN'].includes(e.target.tagName) ) {
      if( !e.target.hasAttribute('data-page') ) { console.log('more-button mist parameter'); return; }
      this.update_archive(e.target.getAttribute('data-page'));
    }
  }

  // Ajax

  update_archive(page) {
    if( this.self_loading ) { console.log('still loading ...'); return; }
    if( this.ajax_url == false ) { console.log('no ajax url'); return; }
    if( this.archive_container == null ) { console.log('empty archive container'); return; }

    const self = this;
    self.start_loading();

    // querystring

    var data = {};

    self.filters_select.forEach( filter => {
      const display = !(window.getComputedStyle(filter, null).display == 'none'); 
      const param_name = filter.getAttribute('data-param');
      const param_value = filter.value;

      if( display && param_value ) {
        data[param_name] = param_value;
      }
    });

    self.filters_checkboxgroup.forEach( filter => {
      const param_name = filter.getAttribute('data-param');
      const param_value = [];

      filter.querySelectorAll('input[type=checkbox]').forEach( (_cb, i) => {
        if( _cb.checked ) {
          param_value.push(_cb.value);
        }
      });

      if( param_value.length > 0 ) {
        data[param_name] = param_value.join(',');
      }
    });

    if( self.search_input && self.search_input.value ) {
      data['srch'] = self.search_input.value;
    }

    data['paging'] = page; // default 1

    const querystring = new URLSearchParams(data).toString();
    const glue = self.ajax_url.includes('?') ? '&' : '?';
    const complete_ajax_url =  self.ajax_url + glue + querystring;

    // ajax-call

    try {
      jQuery.get(complete_ajax_url, function (data) {
        try {
          // Default Ajax afhandeling
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");
          const newContent = htmlDoc.getElementById( self.archive_container.id );

          if( page == 1 ) {
            self.archive_container.innerHTML = newContent.innerHTML;
          } else {
            const more_btn = self.archive_container.querySelector('.' + self.more_button_classname);
            if( more_btn ) more_btn.remove();
            self.archive_container.innerHTML += newContent.innerHTML;
          }
          if( self.counter )
            self.counter.innerHTML = htmlDoc.getElementById(self.counter.id).innerHTML;

          // handle button-events via mutationobserver
        } catch (e) {
          console.log(e);
        }
      })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        })
        .always(function () {
          self.stop_loading();
        });
    } catch (e) {
      self.stop_loading();
    }

  }

}